import { useQuery } from '@tanstack/react-query';
import { getAuditInvitationsForMe } from '../api/getAuditInvitationsForMe';

export const useDoesUserHaveAnyAuditInvitations = (isAuditor = false): boolean => {
  const query = useQuery({
    enabled: isAuditor,
    queryKey: ['does-user-have-any-audit-invitation'],
    queryFn: () =>
      getAuditInvitationsForMe({ page: 1, pageSize: 1, search: '', sortBy: null, filters: null }),
  });

  if (query.isLoading) return false;

  if (query.error) return false;

  if (!query.data) return false;

  return query.data?.results.length > 0;
};
